<template>
  <el-row type="flex" justify="center" v-if="$route.name === 'Payments'">
    <el-col v-if="['DRAFT', 'OPEN', 'AUDITED'].includes(params.data.status)">
      <el-button-group>
        <el-button size="small" plain disabled>
          {{ params.data.status }}
        </el-button>
        <el-button type="info" size="small" :loading="params.postingPayment && params.postingPayment === params.data.id" v-if="params.data.ach_status_message === null || params.data.ach_status_message.length === 0 "
          @click="postPayment(params.data)">
          {{ params.postingPayment && params.postingPayment === params.data.id ? '' : 'Mark as Printed' }}
        </el-button>
      </el-button-group>
      <el-tag v-if="params.data.ach_status_message !== 'null'" style="background-color: transparent; color: black;">
        {{params.data.ach_status_message ? params.data.ach_status_message : '' }}
      </el-tag>
    </el-col>
    <el-col v-else-if="params.data.status === 'POSTED'">
      <el-button-group v-if="params.data.recon === null">
        <el-button size="small" plain disabled v-if="params.data.ach_status_message === null || params.data.ach_status_message.length === 0 ">
          PRINTED
        </el-button>
        <el-button type="danger" size="small" v-if="params.data.ach_status_message === null || params.data.ach_status_message.length === 0 "
          :loading="(params.voidingPayment && params.voidingPayment === params.data.id) || (params.loadingRelated && params.loadingRelated === params.data.id)"
          @click="clickhandleVoidDialogVisible(params.data)">
          {{ params.voidingPayment && params.voidingPayment === params.data.id ? '' : 'Void Payment' }}
        </el-button>
      </el-button-group>
      <el-tag type="gray" v-else>
        CLEARED
      </el-tag>
      <el-tag  v-if="params.data.ach_status_message !== 'null'" style="background-color: transparent; color: black;">
        {{params.data.ach_status_message ? params.data.ach_status_message : '' }}
      </el-tag>
    </el-col>
    <el-col v-else-if="params.data.status === 'CLOSED'">
      <el-tag type="gray">
        {{ params.data.recon ? 'CLEARED' : params.data.status }}
      </el-tag>
      <el-tag  v-if="params.data.ach_status_message !== 'null'" style="background-color: transparent; color: black;">
        {{params.data.ach_status_message ? params.data.ach_status_message : '' }}
      </el-tag>
    </el-col>
    <el-col v-else>
      <el-tag type="gray">
        {{ params.data.status }}
      </el-tag>
      <el-tag  v-if="params.data.ach_status_message !== 'null'" style="background-color: transparent; color: black;">
        {{params.data.ach_status_message ? params.data.ach_status_message : '' }}
      </el-tag>
    </el-col>
  </el-row>
  <el-row v-else type="flex" justify="center">
    <el-col v-if="['OPEN', 'AUDITED'].includes(params.data.status)">
      <el-button-group>
        <el-button size="small" plain disabled>
          {{ params.data.status }}
        </el-button>
        <el-button type="info" size="small" :disabled="checkIfBtnShouldBeDisabled(params.data.id)"
          :loading="checkIfBtnShouldBeDisabled(params.data.id)" @click="handleAuditBtnClick(params.data, getTxtName)">
          {{ checkIfBtnShouldBeDisabled(params.data.id) ? '' : 'Audit' }}
        </el-button>
      </el-button-group>
      <el-tag  v-if="params.data.ach_status_message !== 'null'" style="background-color: transparent; color: black;">
        {{params.data.ach_status_message ? params.data.ach_status_message : '' }}
      </el-tag>
    </el-col>
    <el-col v-else-if="params.data.status === 'DRAFT'">
      <el-tag type="primary">
        {{ params.data.status }}
      </el-tag>
      <el-tag v-if="params.data.ach_status_message !== 'null'" style="background-color: transparent; color: black;">
        {{params.data.ach_status_message ? params.data.ach_status_message : '' }}
      </el-tag>
    </el-col>
    <el-col v-else>
      <el-tag type="gray">
        {{ params.data.status }}
      </el-tag>
      <el-tag  v-if="params.data.ach_status_message !== 'null'" style="background-color: transparent; color: black;">
        {{params.data.ach_status_message ? params.data.ach_status_message : '' }}
      </el-tag>
    </el-col>
  </el-row>
</template>
<script>
import Vue from 'vue'
import { listViewMixins } from '@/Mixins/TransactionListViews'
export default Vue.extend({
  mixins: [listViewMixins],
  methods: {
    clickhandleVoidDialogVisible (data) {
      this.params.clickhandleVoidDialogVisible(data)
    },
    postPayment (data) {
      this.params.postPayment(data)
    }
  },
  computed: {
    getTxtName () {
      return this.$route.meta.prettyName
    }
  },
  watch: {
    postingPayment (val) {
      this.postingPayment = val
    },
    voidingPayment (val) {
      this.voidingPayment = val
    },
    loadingRelated (val) {
      this.loadingRelated = val
    }
  }
})
</script>


// WEBPACK FOOTER //
// src/components/SigmaClientNew/AgGridBtnRender.vue